/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/fortune_ball'
export default icon
